var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isImageValid)?_c('div',{staticClass:"copilot-anpr-thumbnail",style:({ height: `${_vm.height}px` })},[_c('img',{staticClass:"copilot-anpr-thumbnail__img",attrs:{"src":_vm.thumbnailUrl,"alt":"thumbnail"},on:{"error":_vm.handleImageError}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }